import { render, staticRenderFns } from "./MoleculeEditionBillingAcademyBillingModalProducts.vue?vue&type=template&id=3bbfb171"
import script from "./MoleculeEditionBillingAcademyBillingModalProducts.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademyBillingModalProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports